<template>
  <section class="careers-intro position-relative see__pad">
    <div class="pattern-layer">
      <div class="pattern-1 position-absolute" style="background-image: url('/shapes/shape-07.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-2 position-absolute" style="background-image: url('/shapes/shape-08.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-3 position-absolute" style="background-image: url('/shapes/shape-09.png')"></div>
    </div>
    <div class="pattern-layer">
      <div class="pattern-4 position-absolute" style="background-image: url('/shapes/shape-10.png')"></div>
    </div>
    
    <div class="header-container">
      <div class="row">
        <div class="col-lg-12">
          <div class="careers-intro-content text-center">
            <div class="careers-section-label">
              <h4>{{ content.header.label }}</h4>
            </div>
            <div class="careers-main-title">
              <h2>{{ content.header.title }}</h2>
            </div>
            <div class="careers-description">
              <p>{{ content.header.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CareersIntroComp',
  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
/* Import Google Fonts */
@import url('https://fonts.googleapis.com/css2?family=Archivo:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap');

/* Import Flaticon */
@import '@/assets/scss/Flaticon.scss';

.see__pad {
  padding: 100px 0;
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* Pattern Layers */
.pattern-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.pattern-1 {
  top: 10%;
  right: 5%;
  width: 100px;
  height: 100px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-2 {
  bottom: 20%;
  left: 8%;
  width: 80px;
  height: 80px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

.pattern-3 {
  top: 30%;
  left: 10%;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.1;
}

.pattern-4 {
  top: 15%;
  right: 15%;
  width: 90px;
  height: 90px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  opacity: 0.08;
}

/* Intro Section */
.careers-intro {
  background: #00061A;
  position: relative;
  overflow: hidden;
}

.careers-intro-content {
  position: relative;
  z-index: 2;
}

.careers-section-label h4 {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 13.2px;
  color: #F6EC4F;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
  text-transform: uppercase;
}

.careers-main-title h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  margin-bottom: 20px;
  font-family: 'Archivo', sans-serif;
}

.careers-description p {
  font-size: 18px;
  color: #fff;
  max-width: 800px;
  margin: 0 auto;
  line-height: 1.8;
}

/* Responsive Design */
@media (max-width: 767px) {
  .careers-main-title h2 {
    font-size: 36px;
    line-height: 46px;
  }
  
  .careers-section-label h4 {
    letter-spacing: 8px;
    font-size: 16px;
  }
}

@media (max-width: 399px) {
  .see__pad {
    padding: 60px 0;
  }
  
  .careers-main-title h2 {
    font-size: 28px;
    line-height: 38px;
  }
}
</style>
